import { render, staticRenderFns } from "./DeterAmazoniaLegalNaoFloresta.vue?vue&type=template&id=479b7244&lang=pug"
import script from "./DeterAmazoniaLegalNaoFloresta.vue?vue&type=script&lang=js"
export * from "./DeterAmazoniaLegalNaoFloresta.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports